// @ts-check
import { gql, useLazyQuery } from '@apollo/client';
import React from 'react';
const EMPTY = '(empty)';

export default function usePartnersSearch({
  workspaceId,
  searchTerm = '',
  countryCode,
  companyType,
}) {
  const [fetchPartners, { data, loading }] = useLazyQuery(query, {
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      fetchPartners({
        variables: {
          workspaceId,
          searchTerm,
          countryCode: countryCode === EMPTY ? null : { eq: countryCode },
          companyType,
        },
      });
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchTerm, countryCode, fetchPartners]);

  return {
    partners: data?.workspace?.importToolPartners?.nodes || [],
    loading,
  };
}

const query = gql`
  query searchPartners(
    $workspaceId: ID!
    $searchTerm: String!
    $countryCode: StringQueryOperatorInput
    $companyType: CompanyType
  ) {
    workspace(workspaceId: $workspaceId) {
      workspaceId
      importToolPartners(
        filter: {
          searchTerm: $searchTerm
          countryCode: $countryCode
          companyType: $companyType
        }
      ) {
        nodes {
          partnerId
          companyId
          name
          aliases
          brand {
            brandId
            name
            street
            city
            postalCode
            country
            logo {
              fixed(height: 80, width: 80, crop: PAD, fetch_format: AUTO) {
                src
                srcSet
              }
            }
          }
        }
      }
    }
  }
`;
